import Service from '../dashboard_services';
import { geoCodeAddress } from '../helper';
import { topRegions } from './mock-data';

export default {
  async fetchTotals({ commit }) {
    const response = await Service.fetchTotals();
    commit('setProperty', { property: 'aggregate', payload: response.totals });
  },

  async fetchCustomers({ commit }) {
    const response = await Service.fetchCustomers();
    commit('setProperty', { property: 'customers', payload: response.newCustomers });

    return response;
  },

  async fetchSalesHistory({ commit }) {
    const response = await Service.fetchSalesHistory();
    commit('setProperty', { property: 'sales', payload: response.salesHistory });

    return response;
  },

  async fetchYearEarnings({ commit }) {
    const response = await Service.fetchYearEarnings();
    commit('setEarningsProperty', { property: 'year', payload: response });

    return response;
  },

  async fetchMonthEarnings({ commit }) {
    const response = await Service.fetchMonthEarnings();
    commit('setEarningsProperty', { property: 'month', payload: response });

    return response;
  },

  async fetchWeekEarnings({ commit }) {
    const response = await Service.fetchWeekEarnings();
    commit('setEarningsProperty', { property: 'week', payload: response });

    return response;
  },

  async fetchAllOrders({ commit }) {
    const response = await Service.fetchTotalOrders();
    commit('setProperty', { property: 'orders', payload: response });

    return response;
  },

  async fetchUploadedProducts({ commit }) {
    const response = await Service.fetchUploadedProducts();
    commit('setProperty', { property: 'products_uploads', payload: response });

    return response;
  },

  async fetchLocationBySalesStats({ commit }) {
    const response = await Service.fetchSalesByLocation();
    commit('setProperty', { property: 'sales_location', payload: response });

    return response;
  },

  async fetchProductSales({ commit }) {
    const response = await Service.fetchProductSales();
    commit('setProperty', { property: 'products_sales', payload: response });

    return response;
  },

  async fetchDataForTopStates({ commit }) {
    const response = await Service.fetchDataForTopRegions();
    commit('setProperty', { property: 'top_states', payload: topRegions.data });

    return response;
  },

  async addressGeoCode({ state, commit }) {
    state.sales_location.map(async (item) => {
      const address = `${item.address} ${item.store_state} ${item.store_country}`;
      const geoCode = await geoCodeAddress(address);
      commit('setGeoCodedData', [geoCode.lat, geoCode.lng, address, parseInt(item.total_sales, 10), parseInt(item.total_amount, 10)]);
    });
  },
};
